// extracted by mini-css-extract-plugin
export default {"Wrapper":"Profile_Wrapper__E18hl","Profile":"Profile_Profile__879BF"};